import * as t from 'io-ts'

const extractIoTsErrorsWithPath = (
  topObjectName: string,
  errors: t.Errors,
): CleanError[] => {
  return errors.map((error) => {
    const context = error.context
    const path = context.reduce((acc, context, currentIndex, array) => {
      const previousValue: t.ContextEntry | undefined = array[currentIndex - 1]
      const previousValueWasArrayType =
        // @ts-ignore
        previousValue && previousValue.type._tag === 'ArrayType'
      const currentKeyIsNumber = !isNaN(Number(context.key))

      if (context.key === '') return acc

      if (previousValueWasArrayType && currentKeyIsNumber)
        return `${acc}[${context.key}]`

      if (!previousValueWasArrayType && currentKeyIsNumber) {
        return acc
      }

      return `${acc}.${context.key}`
    }, topObjectName)
    const lastContext = context[context.length - 1]

    return {
      path,
      expected: lastContext.type.name,
      found: JSON.stringify(lastContext.actual),
    }
  })
}

export type CleanError = {
  path: string
  expected: string
  found: string
}

export default extractIoTsErrorsWithPath
